import { Directive, Input, AfterViewInit, ElementRef } from '@angular/core';

@Directive({ selector: '[nav-menu]' })

export class NavMenuDirective implements AfterViewInit {
    @Input('menu-options') menuOptions: any;
    private menuElement: HTMLElement;

    constructor(private elementRef: ElementRef) {
        this.menuElement = elementRef.nativeElement as HTMLElement;
        this.menuOptions = this.menuOptions || {selector: '', hoverClass: ''};
    }

    public ngAfterViewInit() {
        var navLinks = this.menuElement.querySelectorAll(this.menuOptions.selector);
        this.menuElement.onmouseenter = () => {
            this.menuElement.classList.add(this.menuOptions.hoverClass);
        };
        this.menuElement.onmouseleave = () => {
            this.menuElement.classList.remove(this.menuOptions.hoverClass);
        };
        for (let i = 0; i < navLinks.length; i++) {
            const anchor = navLinks.item(i) as HTMLElement;
            anchor.onclick = () => {
                this.menuElement.classList.remove(this.menuOptions.hoverClass);
            };
        }
    }
}
